import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { FakturaResponse } from './faktura.types';
import { AnalyticsService } from '../analytics/analytics.service';

@Injectable({
  providedIn: 'root'
})
export class FakturaService {
  constructor(
    private _httpClient: HttpClient,
    private analytics: AnalyticsService
  ) {}

  getFakturaList(): Observable<FakturaResponse> {
    return this._httpClient
      .get<FakturaResponse>(
        'https://apiprivat.ishavskraft.no/faktura/list/24/1'
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.analytics.logEvent_errorFetch(
            'https://apiprivat.ishavskraft.no/faktura',
            `Status ${error.status} ${error.statusText} - ${error.url}`
          );
          return of(null);
        })
      );
  }
}
